import useSWR from 'swr';
import { api } from '../lib/api';
import type { AppEnvironmentResponse } from '../types';

/**
 * Returns the deploy environment (dev | staging | prod) this dashboard is
 * running against, plus whether registry import is enabled. The data rarely
 * changes during a session, so revalidation is disabled — components can rely
 * on a single cached fetch.
 */
export function useAppEnvironment() {
  const { data } = useSWR<AppEnvironmentResponse>(
    '/api/settings/app-environment',
    () => api.getAppEnvironment(),
    { revalidateOnFocus: false, revalidateIfStale: false, refreshInterval: 0 }
  );
  return data;
}
